import { clientHeadersMapper } from 'helpers/client-headers-mapper'

interface Props {
  contentType: string
  url: string
  method?: string
  blob: Blob
  handleUploadProgress?: Function
  setRequest?: Function
  handleError?: Function
  handleUploadDone?: Function
  isNeedCache?: boolean
  headers?: Record<string, string[]>
}

export function makeXMLRequest({
  contentType,
  url,
  method = 'PUT',
  blob,
  handleUploadProgress = undefined,
  setRequest = undefined,
  handleError = undefined,
  handleUploadDone = () => {},
  isNeedCache = true,
  headers,
}: Props) {
  return new Promise(function (resolve) {
    let oReq = new XMLHttpRequest()
    if (setRequest) setRequest(oReq)

    oReq.open(method, url, true)
    if (headers) {
      const mappedHeaders = clientHeadersMapper(headers)
      for (const key in mappedHeaders) {
        oReq.setRequestHeader(key, mappedHeaders[key])
      }
    } else {
      oReq.setRequestHeader('Content-Type', contentType)
      if (isNeedCache) {
        oReq.setRequestHeader('Cache-Control', 'max-age=31536000')
      }
    }

    oReq.upload.addEventListener('progress', function (event) {
      if (event.lengthComputable && handleUploadProgress) {
        const progress = (event.loaded / event.total) * 100
        handleUploadProgress(progress | 0)
      }
    })
    oReq.onload = function () {
      resolve(oReq.response)
      handleUploadDone()
    }
    oReq.onerror = function () {
      if (handleError) handleError()
    }
    oReq.send(blob)
  })
}
